	 $('.info_responsive').slick({
  dots: false,
  infinite: true,
  autoplay : false,
  speed: 800,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow:'<button class="slide-arrow next-arrow info-right-arrow"><div class=" col-image-button-icon"><svg width="34" height="49" viewBox="0 0 34 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33 0.999998L2 24.5L33 48" stroke="white" stroke-width="2"/></svg></div></button>',
  nextArrow: '<button class="slide-arrow prev-arrow info-left-arrow"><div class="col-image-button-icon-prev"><svg width="34" height="49" viewBox="0 0 34 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 48L32 24.5L0.999999 1" stroke="white" stroke-width="2"/></svg></div></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay : true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay : true
      }
    }
  ]
});

if ($(window).width() < 768) {
  $('.ps_colection_list').slick({
  arrows:false,
  dots: false,
  infinite: true,
  autoplay : true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1
});
}

//recommendation slider on mobile
    if ($(window).width() < 768) {
      var count = 0;
    setTimeout(()=>{
        count = 1;
  $('.ps_recommendation').slick({
  arrows:false,
  dots: false,
  infinite: true,
  autoplay : true,
  speed: 800,
  slidesToShow: 2,
  slidesToScroll: 2
});
},2000)
      if(count == 1){
 $(function() {
        $('.ps_recommendation').slick({
        arrows:false,
        dots: false,
        infinite: true,
        autoplay : true,
        speed: 800,
        slidesToShow: 2,
        slidesToScroll: 2
        });
      });
   }
    }

// $(".Click-here").on('click', function() {
//   $(".custom-model-main").addClass('model-open');
// }); 
// $(".close-btn, .bg-overlay").click(function(){
//   $(".custom-model-main").removeClass('model-open');
// });
// When the user scrolls down 50px from the top of the document, resize the header's font size
//window.onscroll = function() {scrollFunction()};

// function scrollFunction() {
//   if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
//     document.getElementById("ProductInfo-template--16076644122792__main").style.top = "11rem";
//   } else {
//     document.getElementById("ProductInfo-template--16076644122792__main").style.top = "20rem";
//     document.getElementById("ProductInfo-template--16076644122792__main").style.transition =".1s";
//   }
// }

// document.getElementById("MegaMenu-Content-2").style.display="block";




// $(".mega-menu").click(function(){
//  $(".mega-menu__content").fadeOut();
   
// });

 // $(".mega-menu").click(function(){
 //    if ($('summary.header__menu-item.list-menu__item.link.focus-inset').attr('aria-expanded') === 'true') {
 //          $(".mega-menu__content").fadeIn();
 //    }
 //   });

$(document).ready(function(){
    // $('summary.header__menu-item.list-menu__item.link.focus-inset').attr('aria-expanded', 'true');
    // if ($('summary.header__menu-item.list-menu__item.link.focus-inset').attr('aria-expanded') === 'true') {
    //     $(".mega-menu__content").fadeIn(1000);
    // }

// $("summary").hover(function () {
//      if ($('summary.header__menu-item.list-menu__item.link.focus-inset').attr('aria-expanded') === 'true') {
//         $(".mega-menu__content").fadeIn(1000);
//     }
// }


  
});
  
// $(".mega-menu").hover(function () {
//   $(".mega-menu__content").addClass("menu-dropdown");
//      if ($('summary.header__menu-item.list-menu__item.link.focus-inset').attr('aria-expanded') === 'true') {
//         $(".menu-dropdown").fadeIn(1000);
//     }
// });


$(document).ready(function(){
   $(".mega-menu__content").addClass("menu-dropdown");
  $(".mega-menu").hover(function () {
     $(".menu-dropdown").fadeIn(1200);
  });
});

$(document).ready(function(){
  $(".mega-menu").click(function(){
    $(".mega-menu__content").addClass("menu-mobile-dropdown");
  });
});

// mobile nevigation
$(document).ready(function () {
    $("ul.menu-drawer__menu.has-submenu li").click(function () {
        //Toggle the child but don't include them in the hide selector using .not()
        $('ul.menu-drawer__menu.has-submenu li > ul.child').not($(this).children("ul.child").toggle()).hide();

    });
});
$(document).ready(function () {
    $("ul.child li").click(function () {
        //Toggle the child but don't include them in the hide selector using .not()
        $(' ul.child li > ul.grandchild').not($(this).children("ul.grandchild").toggle()).hide();
    });
});


//this is the button
var acc = document.getElementsByClassName("course-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  //when one of the buttons are clicked run this function
  acc[i].onclick = function () {
    //variables
    var panel = this.nextElementSibling;
    var coursePanel = document.getElementsByClassName("course-panel");
    var courseAccordion = document.getElementsByClassName("course-accordion");
    var courseAccordionActive = document.getElementsByClassName(
      "course-accordion active"
    );

    /*if pannel is already open - minimize*/
    if (panel.style.maxHeight) {
      //minifies current pannel if already open
      panel.style.maxHeight = null;
      //removes the 'active' class as toggle didnt work on browsers minus chrome
      this.classList.remove("active");
    } else {
      //pannel isnt open...
      //goes through the buttons and removes the 'active' css (+ and -)
      for (var ii = 0; ii < courseAccordionActive.length; ii++) {
        courseAccordionActive[ii].classList.remove("active");
      }
      //Goes through and removes 'activ' from the css, also minifies any 'panels' that might be open
      for (var iii = 0; iii < coursePanel.length; iii++) {
        this.classList.remove("active");
        coursePanel[iii].style.maxHeight = null;
      }
      //opens the specified pannel
      panel.style.maxHeight = panel.scrollHeight + "px";
      //adds the 'active' addition to the css.
      this.classList.add("active");
    }
  }; //closing to the acc onclick function
} //closing to the for loop.


// 3 time reload product page that show a popup logic 
/* document.addEventListener('DOMContentLoaded', () => {
  const pathParts = window.location.pathname.split('/');
  const productIndex = pathParts.indexOf('products');
  const currentHandle = productIndex !== -1 ? pathParts[productIndex + 1] : null;

  const StockText = document.querySelector('.stock-text');

  if (currentHandle) {
    const visits = JSON.parse(localStorage.getItem('product_visits') || '{}');
    const shownHandle = localStorage.getItem('shown_product_handle');

    // Increment visit count
    visits[currentHandle] = (visits[currentHandle] || 0) + 1;
    localStorage.setItem('product_visits', JSON.stringify(visits));

    // Show text if:
    // - It was already shown for this product (even on refresh)
    // - OR this product has been visited 3+ times
    if (shownHandle === currentHandle || visits[currentHandle] >= 3) {
      console.log("Show stock text");
      StockText.style.display = 'block';
      localStorage.setItem('shown_product_handle', currentHandle);
    } else {
      StockText.style.display = 'none';
    }

    // Update last visited product
    localStorage.setItem('last_visited_product', currentHandle);
  }
});

 */
// buy-pay popup
document.addEventListener("DOMContentLoaded", function () {
  const strongEl = document.querySelector(".buy-pay-details-popup strong");

  if (strongEl) {
    strongEl.style.cursor = "pointer"; // make clickable
    strongEl.addEventListener("click", function () {
      Swal.fire({
        title: "Buy Now, Pay Later",   // ✅ Header set here
        showConfirmButton: false,
        confirmButtonText: "Close",
        width: 600,
        showCloseButton: true, // top-right X
        html: `
          <div class="icon_wrap" style="display:flex;align-items:flex-start;gap:20px;text-align:left;">
            <img src="https://cdn.shopify.com/s/files/1/0592/4959/0440/files/afterpay_logo.svg?v=1755510806" 
                 alt="Afterpay" style="max-width:120px;height:auto;">
            <ul style="margin:0;padding-left:20px;list-style:disc;">
              <li>Repay in 4 instalments fortnightly.</li>
              <li>The maximum purchase amount is $1,200.</li>
              <li>Available in AUS, NZ, Canada and U.S</li>
              <li>Learn more about Afterpay <a href="https://www.afterpay.com/en-AU" target="_blank" class="pay_here_link">here</a></li>
            </ul>
          </div>
        `
      });
    });
  }
});
